"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileTypeOptions = void 0;
const graphql_zeus_1 = require("graphql-zeus");
exports.compileTypeOptions = ({ type }) => {
    var _a, _b, _c;
    let compiledType = type.name;
    if ((_a = type.options) === null || _a === void 0 ? void 0 : _a.includes(graphql_zeus_1.Options.required)) {
        compiledType = `${compiledType}!`;
    }
    if ((_b = type.options) === null || _b === void 0 ? void 0 : _b.includes(graphql_zeus_1.Options.array)) {
        compiledType = `[${compiledType}]`;
        if ((_c = type.options) === null || _c === void 0 ? void 0 : _c.includes(graphql_zeus_1.Options.arrayRequired)) {
            compiledType = `${compiledType}!`;
        }
    }
    return compiledType;
};
